import { ReactElement } from 'react';
import clsx from 'clsx';
import Button, { ButtonProps } from '@components/Button';
import Icon from '@components/Icon';
import TokenAssetAvatar from '@components/TokenAssetAvatar';
import { TokenAsset } from '@types';
import { getUrlWithBasePathOrPublicUrl } from '@lib/utils';

interface SelectAssetButtonProps extends Omit<ButtonProps, 'children'> {
  iconClassName?: string;
  tokenAsset?: TokenAsset | null;
  className?: string;
}

function SelectAssetButton({
  iconClassName,
  tokenAsset,
  className,
  ...rest
}: SelectAssetButtonProps): ReactElement {
  return (
    <Button className={clsx('h-[60px]', className)} {...rest}>
      <span className="flex flex-row items-center mr-3">
        {tokenAsset ? (
          <>
            <span className="mr-2 flex w-2 h-2">
              <TokenAssetAvatar
                height={2}
                name={tokenAsset.name}
                src={getUrlWithBasePathOrPublicUrl(tokenAsset.logoURI)}
                width={2}
              />
            </span>
            <span>{tokenAsset.symbol}</span>
          </>
        ) : (
          <span>Assets</span>
        )}
      </span>
      <Icon.ArrowDown
        className={clsx('ml-auto text-iconLarge', iconClassName)}
      />
    </Button>
  );
}

export default SelectAssetButton;
